import { BackgroundWrapper } from "../../atoms/backgroundWrapper/BackgroundWrapper";
import { Container } from "../../atoms/container/Container";
import { Text } from "../../atoms/text/Text";
import { options, questions, DoctorConsultDeniedScript } from "../../../utils/helper";
import { MedicalCondList } from "../../molecules/medicalCondList/MedicalCondList";
import { useMedicalCondition } from "../../../hooks/useMedicalCondtion/UseMedicalCondition";
import { AgentScript } from "../../atoms/agentScript/AgentScript";
import { Flex } from "antd";
import style from "./patientcondition.module.scss";

export const PatientCondition = () => {
  const { responses, handleOptionChange } = useMedicalCondition();
  const isDoctorDenied = responses.isAmbulanceRequired === "Yes" && responses.isDoctorConsultationRequired === "No";
  return (
    <>
      <BackgroundWrapper className={style.wrapper}>
        <Container>
          <Flex className={style.labelRow}>
            <Text text="Support Requirements" className={style.title} />
            <AgentScript
              text='"I will now arrange the required support for you."'
              className={style.mobileOnly}
            />
          </Flex>
          <AgentScript
            text='"I will now arrange the required support for you."'
            className={style.desktopOnly}
          />
        </Container>
        {questions.map((q: any) => (
          <MedicalCondList
            className={style.question}
            key={q.name}
            question={q.text}
            options={options}
            name={q.name}
            value={responses[q.name]}
            onChange={handleOptionChange}
            disable={false}
            extra={
              q.name === "isDoctorConsultationRequired" && isDoctorDenied
                ? <AgentScript text={DoctorConsultDeniedScript} className={style.mobileOnly} />
                : undefined
            }
          />
        ))}
        {isDoctorDenied && (
          <AgentScript text={DoctorConsultDeniedScript} className={style.desktopOnly} />
        )}
      </BackgroundWrapper>
    </>
  );
};
